module.exports = function getResource(label) {
    const resources = {
        gotIt: 'Got It',
        basketUrgencyMessage: 'Items in your basket are not reserved until you checkout.'
    };

    return resources[label];
};
